export enum InputType {
    PULSEM_ACCOUNT_ID = 'pulsem_account_id',
    TEXT = 'text',
    CHECKBOX = 'checkbox',
    COMBOBOX = 'combobox',
    DROPDOWN = 'dropdown',
    MULTI_DROPDOWN = 'multi_dropdown',
    ORDERED_LIST = 'ordered_list',
    RADIO = 'radio'
}


export interface TextInputOptions {
    type: 'text'|'number';
    prefix: string|null;
}


export interface CheckboxOptions {
    defaultValue: boolean;
}


export interface ComboboxOptions {
    type: 'text'|'number';
}


export interface AsyncableInputOptions<V extends MultiValue> {
    asyncLoad: {
        loadOn: string[];
    };
    inputValues: V[]; // Can be it's own type once it deviates further.
}


export interface MultiValue {
    display: string;
    value: string|null;
}


export interface OpenEndedInput {
    display: string;
}


export interface DropdownInputOptions extends AsyncableInputOptions<MultiValue> {
    asyncLoad: {
        loadOn: string[];
    };
    inputValues: MultiValue[]; // Can be it's own type once it deviates further.
}


export interface ListItem extends MultiValue {
    href: string;
}


export interface OrderedListOptions extends AsyncableInputOptions<ListItem> {
    asyncLoad: {
        loadOn: string[];
    };
    inputValues: ListItem[];
    fieldPlaceholder: string;
    additionalFields: string[];
}


export interface RadioInputOptions extends AsyncableInputOptions<MultiValue> {
    asyncLoad: {
        loadOn: string[];
    };
    inputValues: MultiValue[]; // Can be it's own type once it deviates further.
    openEndedInput: null|OpenEndedInput;
}


export interface InputField {
    key: string;
    label: string;
    inputType: InputType;
    inputOptions:
        TextInputOptions|CheckboxOptions|ComboboxOptions|
        DropdownInputOptions|OrderedListOptions|RadioInputOptions;
}
